import UserStore from '../../stores/UserStore';
import template from '../../helpers/template';
import typeOf from '../../helpers/typeOf';
import Helpers from './Helpers';
import store from '../../stores/redux';
import {
    metrics,
    treeMetric
} from './config';
import runtimeConfig from '../../config/runtimeConfig';

let currentKeyReportGroupBy = 'Day';
let defBinaryMetric = '';

class Utils extends Helpers {
    getTitleChain(key, delimiter = ' → ') {
        let titles = [];

        const fn = (item, params) => {
            const config = item.config;
            let find = false;

            if (config.metrics && config.metrics.indexOf(key) !== -1) {
                find = true;
                titles.unshift(this.getTitle(metrics[key].titleKey || key));
                titles.unshift(this.getTitle(config.titleKey || config.key));
            } else if (config.children) {
                find = this.find(fn, treeMetric, {
                    find: true,
                    level: params.nextLevel,
                    parentKey: config.key
                });

                find && titles.unshift(this.getTitle(config.titleKey || config.key));
            }

            return find;
        };

        if (key === 'GroupBy') {
            titles.push(this.getGroupBy().title);
        } else {
            this.find(fn, treeMetric, {find: true});
        }

        return titles.join(delimiter);
    }

    getTitle(key, titleTemplate) {
        const staticNames = UserStore.getTranslation().report;
        let title = staticNames.title[key];

        if (titleTemplate) {
            title = template(titleTemplate, {title});
        }

        return title;
    }

    getDescription(key) {
        const staticNames = UserStore.getTranslation().report;

        return staticNames.description[key];
    }

    setKeyGroupBy(key) {
        key && (currentKeyReportGroupBy = key);
    }

    getGroupBy(data = {}) {
        let metricGroupBy = metrics.GroupBy[currentKeyReportGroupBy];

        if (undefined === metricGroupBy) {
            this.setKeyGroupBy(runtimeConfig.defaultGroupBy);
            metricGroupBy = metrics.GroupBy[currentKeyReportGroupBy];
        }

        return {
            ...data,
            title: metricGroupBy?.title || currentKeyReportGroupBy
        };
    }

    findMetrics(list, config) {
        config.metrics.map((key) => {
            let data = metrics[key];

            list.push({
                title: this.getTitle(data.titleKey || key),
                description: this.getDescription(data.titleKey || key),
                isSortable: "boolean" === typeof data.isSortable ? data.isSortable : false,
                config: {
                    key,
                    parentKey: config.key
                }
            });
        });
    }

    find(fn, data, params = {}) {
        const level = params.level || 0;
        let nextLevel = level + 1;
        let timeData = null;
        let find = params.find || false;

        data[level]
            .filter((item) => !params.parentKey || item.config.parentKey === params.parentKey)
            .find((item) => {
                timeData = fn(item, {
                    level,
                    nextLevel
                });

                return find && !!timeData;
            });

        return timeData;
    }

    getMultiLevelHeaderNames() {
        let header = Array.from(new Array(treeMetric.length + 1), () => []);
        let countMetrics = 0;

        const fn = (item, params) => {
            const config = item.config;
            let count = 0;
            let data = {};

            if (config.key !== 'GroupBy') {
                if (config.metrics) {
                    count += config.metrics.length;
                    this.findMetrics(header[treeMetric.length], config);
                } else {
                    count = this.find(fn, treeMetric, {
                        level: params.nextLevel,
                        parentKey: config.key
                    });
                }

                data = {
                    ...item,
                    title: this.getTitle(config.titleKey || config.key, config.titleTemplate),
                    description: this.getDescription(config.key),
                    colspan: count
                };
            } else {
                data = this.getGroupBy(item);
            }

            header[params.level].push(data);
            return countMetrics += count;
        };

        this.find(fn, treeMetric);

        return header;
    }

    getDefStrMetric() {
        const { report: { metrics } = {} } = store.getState().serverStorage.store;
        return metrics || this.getStrMetric();
    }

    getStrMetric(list) {
        const isArray = list && typeOf.isArray(list);
        let str = '';

        if (!isArray && defBinaryMetric) {
            return defBinaryMetric;
        }

        for (let key in metrics) {
            if (key === 'GroupBy') {
                str += '1';
                continue;
            }

            if (isArray) {
                list.indexOf(key) !== -1 ? str += '1' : str += '0';
            } else {
                metrics[key].visible ? str += '1' : str += '0';
            }
        }

        !isArray && (defBinaryMetric = str);

        return str;
    }

    getKeysMetric(param) {
        let keys = [];

        Object.keys(metrics).map((key, i) => {
            if (typeOf.isString(param)) {
                +param.charAt(i) && keys.push(key);
            } else if (typeOf.isBoolean(param) && param) {
                metrics[key].visible && keys.push(key);
            } else {
                keys.push(key);
            }
        });

        return keys;
    }

    updateVisible(data, keys) {
        let total = 0;
        const length = data.length - 1;
        const fn = (item, params) => {
            let config = item.config;
            let count = 0;

            params.level === 0 && (total = 0);

            if (config.metrics) {
                config.metrics.map((metricKey) => {
                    let item = data[length].find((item) => item.config.key === metricKey);
                    let visible = keys.indexOf(metricKey) !== -1;

                    item.visible = visible;
                    visible && (count += 1);
                });
            } else if (config.children) {
                count = this.find(fn, data, {
                    level: params.nextLevel,
                    parentKey: config.key
                });
            }

            item.visible = item.config.key === 'GroupBy' ? true : !!count;
            item.colspan = count;
            return total += count;
        };

        this.find(fn, data);
    }
}

export default Utils;
